import { NavLink, Outlet } from 'react-router-dom'
import {
  LayoutDashboard,
  Server,
  Cpu,
  Boxes,
  Network,
  ShieldCheck,
  Globe,
  Workflow,
  Container,
  KeyRound,
  Lock,
  Wrench,
} from 'lucide-react'
import { cn } from '@/lib/utils'

const NAV_ITEMS = [
  { to: '/overview', label: 'Overview', icon: LayoutDashboard },
  { to: '/services', label: 'Services', icon: Boxes },
  { to: '/containers', label: 'Containers', icon: Container },
  { to: '/topology', label: 'Topology', icon: Workflow },
  { to: '/servers', label: 'Servers', icon: Server },
  { to: '/instances', label: 'Instances', icon: Cpu },
  { to: '/mcp-actions', label: 'MCP Actions', icon: Wrench },
  { to: '/networks', label: 'Networks', icon: Network },
  { to: '/certificates', label: 'Certificates', icon: ShieldCheck },
  { to: '/dns', label: 'DNS', icon: Globe },
]

const CREDENTIALS_NAV_ITEMS = [
  { to: '/credentials/gitea-bots', label: 'Gitea Bots', icon: KeyRound },
  { to: '/credentials/secret-stores', label: 'Secret Stores', icon: Lock },
]

export default function Layout() {
  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <aside className="w-60 border-r border-border bg-card px-4 py-6 flex flex-col">
        <div className="mb-8">
          <h1 className="text-lg font-semibold tracking-tight">MOS Control Center</h1>
          <p className="text-xs text-muted-foreground mt-1">Platform admin</p>
        </div>
        <nav className="flex-1 space-y-1">
          {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-secondary text-secondary-foreground'
                    : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground',
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
          {/* Credentials section — Gitea bot PAT management (Phase 1b) */}
          <div className="pt-4 mt-4 border-t border-border">
            <p className="px-3 py-1 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              Credentials
            </p>
            {CREDENTIALS_NAV_ITEMS.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-secondary text-secondary-foreground'
                      : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground',
                  )
                }
              >
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
          </div>
        </nav>
        <div className="pt-6 mt-6 border-t border-border text-xs text-muted-foreground">
          v0.1.0 · scaffolding
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
